import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { FormGroup } from '@angular/forms';
import { IsEmpty } from './isEmpty';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';

const NODE_TYPE = "isEmpty";

@Component({
  selector: 'app-is-empty',
  templateUrl: './is-empty.component.html',
  styleUrls: ['./is-empty.component.scss']
})
export class IsEmptyComponent extends NodeBuilder implements OnInit {

  isEmptyForm: FormGroup

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: { [index: string]: any }) {
    this.isEmptyForm = IsEmpty.toForm(stepData, this.canEdit);

    if ( this.isEmptyForm.get('yes').value === newStepValue) {
      this.isEmptyForm.get('yes').setValue('step' + this.getNextStep());
    }
    if ( this.isEmptyForm.get('no').value === newStepValue) {
      this.isEmptyForm.get('no').setValue('step' + this.getNextStep());
    }
  }

  get getStepData(): {} {
    const formData = this.isEmptyForm.getRawValue();
    return new IsEmpty(formData).nodeData;
  }

  get isNodeValid(): boolean {
    this.isEmptyForm.markAllAsTouched();
    return this.isEmptyForm.valid;
  }
}
